import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconCaretDown = () => {
  return (
    <ControlSafe>
      <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.404 0.527344L1.23248 0.527344C0.34157 0.527344 -0.104599 1.60448 0.525366 2.23445L6.11116 7.82024C6.50168 8.21076 7.13484 8.21076 7.52537 7.82024L13.1112 2.23445C13.7411 1.60449 13.295 0.527344 12.404 0.527344Z"
          fill="#002C98"
        />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconCaretDown)
